import { ResultComponent } from './result/result.component';
import { HomeComponent } from './home/home.component';
import { ResultChildRoutes } from './result/result.routing';

export const ShowDeletedChildRoutes = [
  {
    path: 'result/:ofuscatedData',
    component: ResultComponent,
    children: ResultChildRoutes,
  },
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/license/show-deleted',
  },
];
